import { useEffect } from "react";
import { getActiveLiveContent } from "../utils/shared/events";
import { useEvents } from "../context/EventsContext";

const useActiveLiveContentSync = () => {
    const { setActiveEventData } = useEvents();

    useEffect(() => {
        const handleStateUpdate = () => {
            const activeLiveContent = getActiveLiveContent() || {};
            setActiveEventData(activeLiveContent);
        };

        window.addEventListener("UpshowStateUpdate", handleStateUpdate);
        return () => window.removeEventListener("UpshowStateUpdate", handleStateUpdate);
    }, [setActiveEventData]);
};

export default useActiveLiveContentSync;
